export const equipmentSecurity = [
  {
    name: 'equipment_security_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
